module.exports = __webpack_public_path__ + "img/zs3.30ba4bdc.png";